export const barFunFinderGradient = {
  background: "linear-gradient(135deg, #1a1a1a, #000000)",
  color: "#ffffff"
};

export default barFunFinderGradient;
